import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAlertComponent } from './share/modals/modal-alert/modal-alert.component';
import FetrapiEnums from "./share/enum/enums";

@Injectable({ providedIn: 'root' })
export class AppService {
  constructor(
    private titleService: Title,
    private modalService: NgbModal
  ) {}

  // Set page title
  set pageTitle(value: string) {
    this.titleService.setTitle(`Fetrapi Portal - ${value}`);
  }

  // Check for RTL layout
  get isRTL() {
    return document.documentElement.getAttribute('dir') === 'rtl' ||
           document.body.getAttribute('dir') === 'rtl';
  }

  // Check if IE10
  get isIE10() {
    return (document as any).documentMode === 10;
  }

  // Layout navbar color
  get layoutNavbarBg() {
    return 'navbar-theme';
  }

  // Layout sidenav color
  get layoutSidenavBg() {
    return 'sidenav-theme';
  }

  // Layout footer color
  get layoutFooterBg() {
    return 'footer-theme';
  }

  // Animate scrollTop
  scrollTop(to: number, duration: number, element = document.scrollingElement || document.documentElement) {
    if (element.scrollTop === to) { return; }
    const start = element.scrollTop;
    const change = to - start;
    const startDate = +new Date();

    // t = current time; b = start value; c = change in value; d = duration
    const easeInOutQuad = (t: any, b: any, c: any, d: any) => {
      t /= d / 2;
      if (t < 1) { return c / 2 * t * t + b; }
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    const animateScroll = () => {
      const currentDate = +new Date();
      const currentTime = currentDate - startDate;
      element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration), 10);
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      } else {
        element.scrollTop = to;
      }
    };

    animateScroll();
  }

  utcToLocal(date: Date) {
    const dDate: Date = new Date(date);
    var newDate = new Date(dDate.getTime() + dDate.getTimezoneOffset()*60*1000);
    var offset = dDate.getTimezoneOffset() / 60;
    var hours = dDate.getHours();
    newDate.setHours(hours + offset);
    return newDate.toLocaleString();   
  }

  showModalError(message: string) { 
    this.showModalAlert(message, FetrapiEnums.ModalType.Error); 
  }

  showModalInfo(message: string) { 
    this.showModalAlert(message, FetrapiEnums.ModalType.Info);
  }

  showModalAlert(message: string, modalType: FetrapiEnums.ModalType = FetrapiEnums.ModalType.Info) {
    const modal = this.modalService.open(ModalAlertComponent);
    modal.componentInstance.showModal(message, modalType);
  }

}
